export const CANVAS_SET_DRAW = 'CANVAS_SET_DRAW'
export const CANVAS_SET_COLOR = 'CANVAS_SET_COLOR'
export const CANVAS_SET_BACKDROP = 'CANVAS_SET_BACKDROP'
export const CANVAS_SET_IMAGE = 'CANVAS_SET_IMAGE'
